﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IExcelCellField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.ExcelCellField, eOutputFieldType.excelCell)
export class ExcelCellField extends OutputField implements IExcelCellField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public deleted: boolean;
}
